<template>
  <div class="shadow-sm tw-rounded-lg" style="height: 400px; width: 100%">
    <div class="tw-flex tw-h-full">
      <div class="tw-w-60 tw-flex-none">
        <div
          class="tw-px-6 tw-py-4 tw-flex tw-flex-col no-select tw-bg-gray-50 tw-rounded-lg"
          style="width: 100%; height: 100%"
        >
          <div
            class="tw-flex tw-items-center tw-cursor-pointer"
            @click="handleAllDocument"
          >
            <div class="tw-flex tw-items-center" style="color: #333">
              <img class="tw-w-6 tw-h-6" src="/icon-wendang.png" alt="" />
              <span class="tw-ml-2 tw-text-xl tw-font-medium">{{
                $t("文档")
              }}</span>
            </div>
          </div>
          <div class="tw-flex tw-flex-col tw-mt-5">
            <div class="tw-flex-1">
              <span class="tw-text-sm" style="color: #666">{{
                $t("文档介绍")
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="tw-flex tw-flex-col tw-overflow-hidden tw-pt-4 tw-pr-4 tw-pl-4 tw-flex-1 hide-scrollbar tw-overflow-y-auto"
      >
        <b-row class="tw-mb-4" v-for="(item, index) in navItems" :key="index">
          <b-col :cols="12">
            <div class="tw-flex tw-items-center tw-mb-2" style="color: #333">
              <div class="tw-cursor-pointer" @click="handleItemClick(item)">
                <span class="tw-text-lg tw-font-medium">{{ item.name }}</span>
                <!-- <b-icon
                  icon="chevron-right"
                  class="tw-w-4 tw-h-4 tw-ml-1"
                ></b-icon> -->
              </div>
            </div>
          </b-col>
          <b-col
            cols="4"
            xl="3"
            v-for="(child, index2) in item.children"
            :key="index2"
          >
            <SelectItem
              :item="child"
              @onSelect="handleToDetail"
              :isShowIcon="false"
              :isShowDesc="false"
            />
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import { documentCategoriesApi, documentsApi } from "@/api/modules/home";
import SelectItem from "./components/SelectItem.vue";
export default {
  name: "DocumentMenu",
  components: {
    SelectItem,
  },
  data() {
    return {
      navItems: [],
      listquery: {
        pageIndex: 1,
        pageSize: 8,
        categoryId: "",
      },
    };
  },
  mounted() {
    this.getCategories();
  },
  methods: {
    stripHtml(html) {
      const temp = document.createElement("div");
      temp.innerHTML = html;
      return temp.textContent || temp.innerText || "";
    },
    // 获取产品分类列表
    async getCategories() {
      documentCategoriesApi({
        pageIndex: 1,
        pageSize: 999,
      }).then(async (res) => {
        if (res.data && res.data.list) {
          // 对分类列表进行排序，将 id 为 6 的项移到最后
          let sortedList = [...res.data.list];
          const index = sortedList.findIndex((item) => item.id === 6);
          if (index !== -1) {
            const item = sortedList.splice(index, 1)[0];
            sortedList.push(item);
          }

          this.navItems = sortedList;
          for (let i = 0; i < this.navItems.length; i++) {
            const documents = await this.getDocuments(this.navItems[i]);
            this.$set(this.navItems, i, {
              ...this.navItems[i],
              children: documents,
            });
          }
        }
      });
    },
    async getDocuments(item) {
      this.listquery.categoryId = item.id;
      this.listquery.pageIndex = 1;
      this.listquery.pageSize = 8;
      try {
        const res = await documentsApi(this.listquery);
        if (res && res.data) {
          return res.data.list || [];
        }
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    handleAllDocument() {
      this.$router.push("/document");
      this.$emit("handleToDetail", null);
    },
    handleToDetail(item) {
      localStorage.setItem("detailForm", JSON.stringify(item));
      this.$emit("handleToDetail", item);
      this.$router.push(`/document/${item.id}?id=${item.id}&isApi=false`);
    },
    handleItemClick(item) {
      this.$emit("handleToDetail", null);
      this.$router.push(`/document?categoryId=${item.id}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.menu-item:hover {
  color: #4077f8;
}

.menu-title-active {
  color: #4077f8;
}

.item-c:hover {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);

  .item-title {
    color: #4077f8 !important;
  }
}
</style>
